'use client';

import { useEffect } from 'react';

import { MissionGtm } from '../utils/gtm/mission/missionGtm';
import { useHistoryMethod } from '../utils/hook/useHistoryMethod';
import { usePathnameMethod } from '../utils/hook/usePathnameMethod';
import { useRouterQuery } from '../utils/hook/useRouterQuery';
import MissionFirstTab from './components/mission/MissionFirstTab';
import MissionSecondTab from './components/mission/MissionSecondTab';
import MissionSustainableTable from './components/mission/MissionSustainableTable';
import MissionTabMenu from './components/mission/MissionTabMenu';

const MissionPageV2 = () => {
  const { pathname } = usePathnameMethod();
  const history = useHistoryMethod();

  const {
    query: { tabIndex = 0 },
    queryString,
  } = useRouterQuery<{ tabIndex?: 1 }>();

  const handleTabToSourcing = (tab: 0 | 1 = 1) => {
    window?.scrollTo({ top: 0 });

    if (tab === tabIndex) return;

    const initialTab = 0;
    const searchParams = new URLSearchParams(queryString);
    if (tab === initialTab) {
      searchParams.delete('tabIndex');
    } else {
      searchParams.append('tabIndex', `${tab}`);
    }
    const stringified = searchParams.toString();

    let queryparams = '';
    if (stringified) queryparams = `?${stringified}`;

    history.replace(pathname + queryparams);
  };

  useEffect(() => {
    new MissionGtm().visit_mission_page();
  }, []);

  return (
    <div className="relative">
      <MissionSustainableTable />
      <MissionTabMenu handleTabToSourcing={handleTabToSourcing} />

      <div className="overflow-hidden">
        <div
          className="flex duration-300"
          style={{
            width: '200%',
            transform: `translateX(-${(tabIndex * 100) / 2}%)`,
          }}
        >
          <div className="w-1/2 shrink-0">
            {tabIndex === 0 && (
              <MissionFirstTab handleTabToSourcing={handleTabToSourcing} />
            )}
          </div>
          <div className="w-1/2 shrink-0">
            {tabIndex === 1 && <MissionSecondTab />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionPageV2;
